// extracted by mini-css-extract-plugin
export var alt = "TeaserList-module--alt--a7b3d";
export var card = "TeaserList-module--card--fea69";
export var cardBody = "TeaserList-module--card-body--d9147";
export var cardContainer = "TeaserList-module--cardContainer--378cf";
export var cardFooter = "TeaserList-module--card-footer--55de8";
export var desktopOnly = "TeaserList-module--desktopOnly--d0d97";
export var main = "TeaserList-module--main--84508";
export var mobileOnly = "TeaserList-module--mobileOnly--0cfa4";
export var styledContainer = "TeaserList-module--styledContainer--98032";
export var subTitle = "TeaserList-module--subTitle--eccf1";
export var textLeft = "TeaserList-module--textLeft--0700b";
export var title = "TeaserList-module--title--dfd9e";
export var visuallyHidden = "TeaserList-module--visuallyHidden--9d7cf";